import { createFileRoute } from '@tanstack/react-router';

import { useLandingRedirect } from '../../auth/use-landing-redirect.js';
import { LoadFailedArea, LoadingArea, TextPage } from '../../components/PlaceholderPage.js';

/**
 * The no-permissions page (`patterns/ui-patterns.md`, 3, "No permissions at
 * all"). It shows only while it is this Account User's landing destination, so
 * nobody stays on it after being granted a permission (`ux.md`, Destinations).
 */
export const Route = createFileRoute('/_app/no-permissions')({
  component: NoPermissionsPage,
});

function NoPermissionsPage() {
  const landing = useLandingRedirect(true, 'no_permissions');

  if (landing.kind === 'failed') return <LoadFailedArea onRetry={landing.retry} />;
  if (landing.kind === 'pending') return <LoadingArea />;

  return (
    <TextPage title="No permissions">
      You don&apos;t hold any permissions in this account. Ask someone who manages users and
      permissions in your account to grant you the ones you need.
    </TextPage>
  );
}
